import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React from 'react';
import { StorageClient } from '@atlaskit/frontend-utilities/storage-client';
import { VARIANT_ORDER } from '../../common/constants';
import { NO_OP, remoteImport } from '../../common/utils';
import { PluginName } from '../../types';
import generateHash from '../generate-hash';
import { setupSystemModules } from '../remote-setup';
import { getUfoExperience } from '../use-remote-module-loader/utils';
var isRemoteModuleConfig = function isRemoteModuleConfig(config) {
  return (config === null || config === void 0 ? void 0 : config.moduleUri) !== undefined;
};
var AtlassianSystemRemoteFrontendSdk = /*#__PURE__*/function () {
  function AtlassianSystemRemoteFrontendSdk(plugin) {
    _classCallCheck(this, AtlassianSystemRemoteFrontendSdk);
    // list of remote modules to be imported
    // map of the above modules
    // map of the remote modules that have been fetched
    _defineProperty(this, "resolvedModuleMap", new Map());
    _defineProperty(this, "storageClient", new StorageClient("remote-module-loader-bifrost-override", {
      storageEngine: 'sessionStorage'
    }));
    this.plugin = plugin;
    this.importMap = this.findPluginManifest(plugin);
    this.setImportMaps([this.importMap]);
    this.renderUfoExperience = getUfoExperience(this.getModuleName(), 'render');
  }

  /**
   * Using the dimensions defined in the plugin, search through the manifest and find the most applicable one
   *
   * @param plugin
   * @private
   */
  _createClass(AtlassianSystemRemoteFrontendSdk, [{
    key: "findPluginManifest",
    value: function findPluginManifest(plugin) {
      if (plugin) {
        var manifestMap = plugin.manifestMap,
          dimensions = plugin.dimensions;
        var manifestEnv = manifestMap.get(dimensions.env);
        if (manifestEnv) {
          // This is not currently allowed in the types but is an escape hatch for not defining any variants
          if (isRemoteModuleConfig(manifestEnv)) {
            return manifestEnv;
          }

          /**
           * If we request a `latest` dimension, but only have `stable` in our map then we use it.
           * If we request a `stable` dimension, but only have `latest` an error will be thrown due to the variant order.
           */
          var variantIndex = VARIANT_ORDER.indexOf(dimensions.variant);
          if (variantIndex > -1) {
            for (var i = variantIndex; i < VARIANT_ORDER.length; i++) {
              var manifestVariant = manifestEnv.get(VARIANT_ORDER[i]);
              if (isRemoteModuleConfig(manifestVariant)) {
                this.variant = VARIANT_ORDER[i]; // set the variant applied for use later

                return manifestVariant;
              }
            }
            throw new Error("No valid \"variant\" dimensions defined in plugin for [".concat(dimensions.variant, "]."));
          }
          throw new Error("Invalid \"variant\" dimension defined in plugin for [".concat(dimensions.variant, "]."));
        }
        throw new Error("No \"env\" dimension defined in plugin for [".concat(dimensions.env, "]."));
      }
      throw new Error('Invalid "plugin" provided to SDK.');
    }
  }, {
    key: "getModuleName",
    value: function getModuleName() {
      var importMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.importMap;
      if (importMap) {
        return importMap.moduleName;
      }
      return '';
    }
  }, {
    key: "loadFromQueryAndSaveToSession",
    value: function loadFromQueryAndSaveToSession(key) {
      try {
        var params = new URLSearchParams(window.location.search);
        if (params.has("".concat(key, "-clear"))) {
          this.storageClient.removeItem(key);
          return undefined;
        }
        if (params.has(key)) {
          var value = params.get(key);
          this.storageClient.setItemWithExpiry(key, value, 3 * 3600 * 1000); // 3 hours in ms
          return value;
        } else {
          var itemStr = this.storageClient.getItem(key);
          if (!itemStr) {
            return undefined;
          }
          return itemStr;
        }
      } catch (error) {
        console.error("Error loading value from query or sessionStorage: ".concat(error));
        return undefined;
      }
    }
  }, {
    key: "addBifrostOverride",
    value: function addBifrostOverride(url) {
      try {
        var _this$plugin, _this$plugin2;
        if (!((_this$plugin = this.plugin) !== null && _this$plugin !== void 0 && _this$plugin.bifrostOverrideKey)) {
          return url;
        }
        var bifrostOverrideValue = this.loadFromQueryAndSaveToSession((_this$plugin2 = this.plugin) === null || _this$plugin2 === void 0 ? void 0 : _this$plugin2.bifrostOverrideKey);
        if (!bifrostOverrideValue) {
          return url;
        }
        var urlToUpdate = new URL(url);
        if (urlToUpdate.protocol === 'https:' || urlToUpdate.protocol === 'http:') {
          var inputParams = new URLSearchParams(urlToUpdate.search);
          inputParams.set('bifrost-override', bifrostOverrideValue);
          urlToUpdate.search = inputParams.toString();
        }
        return urlToUpdate.toString();
      } catch (e) {
        console.error('Error adding bifrost override to url. Falling back to original url.');
        return url;
      }
    }

    /**
     * If a moduleUriMapper is defined on the plugin, then we call it passing through the hash function.
     * Otherwise return the moduleUri defined in the import map
     *
     * @param importMap
     */
  }, {
    key: "getModuleUri",
    value: function getModuleUri() {
      var importMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.importMap;
      if (importMap) {
        var _this$plugin3, _this$plugin4;
        var moduleUri = importMap.moduleUri;
        if ((_this$plugin3 = this.plugin) !== null && _this$plugin3 !== void 0 && _this$plugin3.moduleUriMapper) {
          moduleUri = this.plugin.moduleUriMapper(importMap.moduleUri, this.variant, generateHash);
        }
        if ((_this$plugin4 = this.plugin) !== null && _this$plugin4 !== void 0 && _this$plugin4.bifrostOverrideKey) {
          moduleUri = this.addBifrostOverride(moduleUri);
        }
        return moduleUri;
      }
      return '';
    }

    /**
     * Returns the module if it has been resolved into the internal module map
     */
  }, {
    key: "getResolvedModule",
    value: function getResolvedModule() {
      return this.resolvedModuleMap.get(this.getModuleName());
    }

    /**
     * Returns whether the module has been registered by SystemJS AND the current SDK
     */
  }, {
    key: "isModuleRegisteredAndValid",
    value: function isModuleRegisteredAndValid() {
      // a module can appear in the registry as `null` if it fails to load
      return System.has(this.getModuleUri()) && !!System.get(this.getModuleUri()) && !!this.getResolvedModule();
    }

    /**
     * Set up our Import Maps dynamically from the provided import config.
     * We also set the plugin.externals into the module registry so that they are shared.
     * However, these are scoped only to our remote import.
     *
     * https://github.com/systemjs/systemjs/blob/main/docs/import-maps.md
     *
     * @param importMaps
     */
  }, {
    key: "setImportMaps",
    value: function setImportMaps(importMaps) {
      var _this = this;
      var scopedModules = null;
      try {
        var _this$plugin5;
        // Set the external packages into the System registry using the locally resolved (from the Product) packages
        scopedModules = setupSystemModules(importMaps.flatMap(function (item) {
          return item.externals;
        }), ((_this$plugin5 = this.plugin) === null || _this$plugin5 === void 0 ? void 0 : _this$plugin5.name) || PluginName.AppSwitcher);
      } catch (e) {
        // TODO add logger
        console.error(e);
      }
      System.addImportMap(importMaps.reduce(function (acc, item) {
        var moduleUri = _this.getModuleUri(item);
        acc.imports[item.moduleName] = moduleUri;
        if (scopedModules && item.externals.length) {
          acc.scopes[moduleUri] = {};
          var _iterator = _createForOfIteratorHelper(item.externals),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var external = _step.value;
              var externalModuleIdentifier = 'name' in external ? external.name : external.module;
              acc.scopes[moduleUri][externalModuleIdentifier] = scopedModules[externalModuleIdentifier];
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
        return acc;
      }, {
        imports: {},
        scopes: {}
      }));
    }

    /**
     * Fire off the request to fetch our module from the System.JS import map.
     * It is then stored in the resolved module map for easy use later.
     */
  }, {
    key: "fetchModule",
    value: (function () {
      var _fetchModule = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var moduleName, module;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.importMap) {
                _context.next = 7;
                break;
              }
              moduleName = this.importMap.moduleName;
              _context.next = 4;
              return remoteImport(moduleName);
            case 4:
              module = _context.sent;
              this.resolvedModuleMap.set(moduleName, module);
              return _context.abrupt("return", module);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchModule() {
        return _fetchModule.apply(this, arguments);
      }
      return fetchModule;
    }())
  }, {
    key: "resolveExport",
    value: function resolveExport(exportName) {
      var resolvedModule = this.getResolvedModule();
      if (resolvedModule) {
        if (exportName) {
          return resolvedModule[exportName];
        }
        return resolvedModule;
      }
    }

    /**
     * Render our resolved module as a React component in the existing React Tree.
     * This DOES NOT create a new root.
     *
     * @param exportName
     * @param props
     * @param fallback
     */
  }, {
    key: "renderComponent",
    value: function renderComponent() {
      var exportName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
      var props = arguments.length > 1 ? arguments[1] : undefined;
      var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var children = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var experience = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var onEvent = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : NO_OP;
      var component = this.resolveExport(exportName);
      if (component) {
        var componentToRender;
        if ( /*#__PURE__*/React.isValidElement(component)) {
          componentToRender = props ? /*#__PURE__*/React.cloneElement(component, props, children) : component;
        } else {
          componentToRender = /*#__PURE__*/React.createElement(component, props, children);
        }
        onEvent({
          type: 'render-complete'
        });
        experience === null || experience === void 0 || experience.success({
          metadata: {
            moduleName: this.getModuleName()
          }
        });
        return componentToRender;
      }
      return fallback;
    }
  }]);
  return AtlassianSystemRemoteFrontendSdk;
}();
export default AtlassianSystemRemoteFrontendSdk;